export default __webpack_public_path__ + "static/assets/8d67c0cc444eaeaca805b0e386d3833c.gif";